import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

import { logInWithEmailAndPassword } from "../../login";

function Login() {
	const navigate = useNavigate();
	const { setUser } = useContext(UserContext);

	const toastInstance = useRef<ToastComponent>(null);

	function toastCreated() {
		toastInstance.current.show();
	}

	async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();
		const { email, password } = event.target.elements;
		try {
			await logInWithEmailAndPassword(email.value.trim(), password.value.trim());
			setUser(localStorage.getItem("userToken"));
			navigate("/admin");
		} catch (error) {
			console.error(error);
			toastCreated();
		}
	}

	return (
		<div className="step-page">
			<ToastComponent
				ref={toastInstance}
				title="Error!"
				content="Usuario o contraseña incorrecta"
				cssClass="e-toast-danger"
				icon="e-error toast-icons"
			/>
			<section>
				<form className="form-login" onSubmit={handleSubmit}>
					<input id="email" name="email" placeholder="Email" type="text" required={true} />
					<input
						id="password"
						name="password"
						placeholder="Contraseña"
						type="password"
						required={true}
					/>
					<button>Iniciar sesión</button>
				</form>
			</section>
		</div>
	);
}

export { Login };
